// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-maintenance-accept[data-v-539b8bb8] {\n  margin: 0 0 16px 0;\n}\n.form-maintenance-accept .element[data-v-539b8bb8] {\n  margin: 0 0 16px 0;\n  width: 100%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
